import { Action, combineActions, handleActions } from "redux-actions";
import {
  initFeaturesPage,
  launchFeature,
  launchFeatureFailure,
  launchFeatureSuccess,
  reloadFeaturesInit,
  reloadFeaturesInitFailure,
  reloadFeaturesInitSuccess,
  resetFeatures,
  resetFeaturesFailure,
  resetFeaturesSuccess,
  toggleFavourite,
  toggleFavouriteFailure,
  toggleFavouriteSuccess,
  toggleFeature,
  toggleFeatureFailure,
  toggleFeatureSuccess,
  unlaunchFeature,
  unlaunchFeatureFailure,
  unlaunchFeatureSuccess,
} from "./actions";
import {
  FeaturesInitData,
  FeaturesState,
  LaunchFeaturePayload,
  ToggleFavouritePayload,
  ToggleFeaturePayload,
  UnlaunchFeaturePayload,
} from "./types";
import { reduxKey } from "./constants";

type FeaturesActionPayload =
  | { data: FeaturesInitData }
  | { errorMessage: string }
  | ToggleFeaturePayload
  | ToggleFavouritePayload
  | LaunchFeaturePayload
  | UnlaunchFeaturePayload
  | Record<string, never>;

const initialState: FeaturesState = {
  featureCountBanner: null,
  groups: [],
  isLoading: false,
  isMutating: false,
  errorMessage: null,
};

const reducers = handleActions<FeaturesState, FeaturesActionPayload>(
  {
    [`${initFeaturesPage}`]: (
      state,
      action: ReturnType<typeof initFeaturesPage>
    ) => ({
      ...state,
      featureCountBanner: action.payload.data.featureCountBanner,
      groups: action.payload.data.groups,
      errorMessage: null,
    }),
    [`${reloadFeaturesInit}`]: (state) => ({
      ...state,
      isLoading: true,
      errorMessage: null,
    }),
    [`${reloadFeaturesInitSuccess}`]: (
      state,
      action: ReturnType<typeof reloadFeaturesInitSuccess>
    ) => ({
      ...state,
      featureCountBanner:
        action.payload.data.featureCountBanner ?? state.featureCountBanner,
      groups: action.payload.data.groups,
      isLoading: false,
      errorMessage: null,
    }),
    [`${reloadFeaturesInitFailure}`]: (
      state,
      action: ReturnType<typeof reloadFeaturesInitFailure>
    ) => ({
      ...state,
      isLoading: false,
      errorMessage: action.payload.errorMessage,
    }),
    [combineActions(
      toggleFeature,
      resetFeatures,
      launchFeature,
      unlaunchFeature,
      toggleFavourite
    ) as unknown as string]: (state) => ({
      ...state,
      isMutating: true,
      errorMessage: null,
    }),
    [combineActions(
      toggleFeatureSuccess,
      resetFeaturesSuccess,
      launchFeatureSuccess,
      unlaunchFeatureSuccess,
      toggleFavouriteSuccess
    ) as unknown as string]: (state) => ({
      ...state,
      isMutating: false,
      errorMessage: null,
    }),
    [combineActions(
      toggleFeatureFailure,
      resetFeaturesFailure,
      launchFeatureFailure,
      unlaunchFeatureFailure,
      toggleFavouriteFailure
    ) as unknown as string]: (
      state,
      action: Action<{ errorMessage: string }>
    ) => ({
      ...state,
      isMutating: false,
      errorMessage: action.payload.errorMessage,
    }),
  },
  initialState
);

export default {
  [reduxKey]: reducers,
};
